import { PublicClientApplication } from '@azure/msal-browser';
import store from "@/store";


const msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_MSAL_CLIENT_ID || '1da955b1-4ce4-481a-a857-0423ac697927',
        authority: process.env.VUE_APP_MSAL_AUTHORITY || 'https://login.microsoftonline.com/bcc93690-805b-4911-b8c1-6e447795ef8b',
        redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI || window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true,
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

// Update isLoggedIn state based on whether there are any accounts
store.commit('setLoggedIn', msalInstance.getAllAccounts().length > 0);


const getAccount = () => {

    return msalInstance.getAllAccounts()[0];
};

const promptForConsent = async () => { 
    try {
        const authRequest = {
            scopes: ['https://management.azure.com/user_impersonation']
        };
        await msalInstance.loginPopup(authRequest);
    } catch (error) {
        console.error('Failed to prompt for consent:', error);
        throw error;
    }
};

const logout = () => {
    const account = getAccount();
    if (account) {
        msalInstance.logoutRedirect({
            account,
            postLogoutRedirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI || window.location.origin,
        });
        store.commit('setLoggedIn', false);
    }
};


export { msalInstance, getAccount, promptForConsent, logout };
